import CustomButton from "../../../UI/CustomButton/CustomButton"
import Field from "../../../UI/Field/Field"
import { AiOutlineMinus } from "react-icons/ai"
import Input from "../../../UI/Form/Input"
import classes from "./StageSection.module.css"
import { cx } from "../../../../Utils/classnames"
import { useEffect, useState } from "react"
import { useFieldArray, Controller } from "react-hook-form"
import DjField from "./DjField"
import { MdArrowForwardIos } from "react-icons/md";
import { Collapse, IconButton } from "@mui/material"

const SlotField = (props) => {
    const { el, idx, index, innerIndex, control, removeSlot, residents } = props

    const [expanded, setExpanded] = useState(false)

    const handleExpandClick = () => {
        setExpanded(!expanded)
    }

    const { fields, remove, append } = useFieldArray({
        control,
        name: `lineup.${index}.stages.${innerIndex}.slots.${idx}.djs`
    })

    const addDj = () => {
        append({ name: "", info_link: "" })
    }

    const removeDj = (idx) => {
        if (fields.length > 1) {
            remove(idx)
        }
    }

    useEffect(() => {
        if (fields.length < 1) {
            addDj()
        }
    }, [])

    

    return (
        <Field direction="column" key={el.id}>
            <div className={classes.header}>
                <div className={classes.left}>
                    <h5>Time Slot {idx + 1}</h5>
                    <IconButton className={expanded ? classes.expanded : ""} onClick={handleExpandClick}>
                        <MdArrowForwardIos/>
                    </IconButton>
                </div>
                <div className={classes.actions}>
                    <CustomButton
                        className={cx(classes.removeBut, classes.smallRemove)}
                        onClick={() => removeSlot(idx)}
                    >
                        <AiOutlineMinus />
                        <span>Remove</span>
                    </CustomButton>
                </div>
            </div>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <Field direction="column">
                    {fields.map((el, djIndx) => (
                        <DjField
                            key={djIndx}
                            el={el}
                            index={index}
                            innerIndex={innerIndex}
                            idx={idx}
                            djIndx={djIndx}
                            control={control}
                            removeDj={removeDj}
                            residents={residents}
                        />
                    ))}
                    <CustomButton onClick={addDj}>Add Artist</CustomButton>
                    <Field>
                        <Controller
                            name={`lineup.${index}.stages.${innerIndex}.slots.${idx}.startAt`}
                            control={control}
                            defaultValue=""
                            rules={{ required: "Required Field!" }}
                            render={({
                                field: { onChange, value, name },
                                fieldState: { error }
                            }) => (
                                <Input
                                    name={name}
                                    onChange={onChange}
                                    value={value}
                                    error={error}
                                    label="Start"
                                    regex={"time"}
                                />
                            )}
                        />
                        <Controller
                            name={`lineup.${index}.stages.${innerIndex}.slots.${idx}.endAt`}
                            control={control}
                            defaultValue=""
                            rules={{ required: "Required Field!" }}
                            render={({
                                field: { onChange, value, name },
                                fieldState: { error }
                            }) => (
                                <Input
                                    name={name}
                                    onChange={onChange}
                                    value={value}
                                    error={error}
                                    label="End"
                                    regex="time"
                                />
                            )}
                        />
                    </Field>
                </Field>
            </Collapse>
        </Field>
    )
}

export default SlotField
